<template>
    <base_location_modal :tabs_advanced="tabs_add">

        <template v-slot:location_general_info="{ location, name }">
            <shopify_general_tab :location="location"></shopify_general_tab>
        </template>


        <template v-slot:shopify_hook="{ location, name }">
            <shopify_hook :location="location"></shopify_hook>
        </template>


    </base_location_modal>
</template>

<script>
import Base_location_modal from "../../base/location_modal/base_location_modal";
import shopify_general_tab from "./tabs/shopify_general_tab";
import Shopify_hook from "./tabs/shopify_hook";

export default {
    name: "shopify_location_modal",

    components: {
        Shopify_hook,
        Base_location_modal,
        shopify_general_tab
    },
    data () {
        return {
            tabs_add : [
                {
                    index : "shopify_hook",
                    title : this.__t('SHOPIFY_HOOK'),
                },
            ]
        }
    },

    methods : {

    }




}
</script>

<style scoped>

</style>
